var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select',{attrs:{"id":"lgbtq","value":_vm.value,"name":"lgbtq","label":"LGBTQ+ Status","placeholder":"Any","placeholder-enabled":"","options":[
    { id: 'true', display_label: 'LGBTQ+' }
  ]},on:{"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }